'use client'

import React, { useState } from 'react'
import dynamic from 'next/dynamic'
import Modal from '../../Modal'
import Spacer from '../../Spacer'
import CategoryTitle from '../../CategoryTitle'
import SimpleBlockContent from '../../SimpleBlockContent'
import styles from './styles.module.css'

import { $neutralGray80, $white } from '../../../styles/colors/primitives'

// FACADE ISLAND (#118 slice 3) — react-youtube deferral.
//
// This section holds the player-open flag in LOCAL component state (Phase B: UI
// ephemera off Overmind) to open a Modal-hosted player, so it CANNOT be a pure
// Server twin. Instead it is a `'use client'`
// FACADE: the SSR/first-hydration render is only the POSTER (the CSS-background
// sideImage + the play button) — ZERO react-youtube JS. <Youtube> (which pulls
// the heavy react-youtube dependency) is code-split via next/dynamic and rendered
// ONLY inside the <Modal> children, and <Modal> mounts its children ONLY while
// `show` is true — i.e. AFTER the user clicks play (a local-state flip that is
// FALSE on the SSR pass AND on the client's first hydration render).
//
// #130 SAFETY: because the lazy <Youtube> is NEVER in the initial tree (modal
// closed on SSR + first render), it synthesizes NO streaming-Suspense boundary
// during SSR/hydration — the boundary (if any) appears only on the post-click
// mount, a pure client transition with no server counterpart. That is precisely
// why this section can be hosted as a STATIC-import island on the RSC server path
// (RenderSectionsServer ISLAND_SECTIONS) without reproducing the footer-reorder
// React #418/#422 class. The initial poster DOM is BYTE-IDENTICAL to the previous
// static-import version (the only change is that the modal's — un-rendered —
// children now resolve <Youtube> lazily), so there is no hydration diff.
const Youtube = dynamic(() => import('../../Youtube'))



function Video({ videoUrl, sideImage, category, theme = {}, title, text, reversed }) {
  const [showModal, setShowModal] = useState(false)

  const themeColorValue = theme.title.match(/\d+/) ? Number(theme.title.match(/\d+/)[0]) : null
  const textColor = themeColorValue && themeColorValue > 40 ? $white : $neutralGray80
  const dark = themeColorValue && themeColorValue < 50

  return (
    <div className={styles.wrapper} style={{ backgroundColor: theme.value }}>
      <div className={styles.contentWrapper}>
        <div className={styles.sideImageWrapper}>
          {/* task #67: styled bg fed the resolved descriptor url */}
          <div className={styles.sideImage} style={{ backgroundImage: sideImage?.src ? `url(${sideImage.src})` : undefined }} />
          {videoUrl && <div className={styles.playIconWrapper}>
            <button className={styles.videoLink} onClick={() => setShowModal(true)}>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              {/* eslint-disable-next-line local-rules/prefer-img-component -- inline chrome icon (play), hand-sized 64x64 from /public */}
              <img src="/playIcon.svg" alt="Play video" width={64} height={64} decoding="async" />
            </button>
          </div>}
        </div>
        <div className={reversed ? `${styles.textWrapper} ${styles.reversed}` : styles.textWrapper}>
          {category && category.title.length > 0 && <CategoryTitle color={category.color.value}>{category.title}</CategoryTitle>}
          <Spacer size={16} />
          <div style={{ color: textColor }}>
            {text && <SimpleBlockContent blocks={text} />}
          </div>
        </div>
      </div>
      {videoUrl && <Modal show={showModal} onClose={() => setShowModal(false)}>
        <div className={styles.youtubeWrapper}>
          <button className={styles.closeButton} onClick={() => setShowModal(false)}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            {/* eslint-disable-next-line local-rules/prefer-img-component -- inline chrome icon (close), hand-sized 24x24 from /public */}
            <img src="/crossIcon.svg" alt="Close" width={24} height={24} decoding="async" />
          </button>
          <Youtube autoplay modestbranding url={videoUrl} width="100%" height="100%" />
        </div>
      </Modal>}
    </div>
  )
}

export default Video
